/* global VXConfig */

import Translations from "../../utils/Translations";
import Constants from '../../flux/Constants.js';
import Flux from '../../flux/Flux.js';

const ft = (key) => Translations.get(`cams_filter.${key}`);
const ftTag = (key) => Translations.get(`tags.${key}`);

const TYPE_VIDEO_FILTER = 'videoFilter';

const _KEYS = {
    COUNTRY: 'country',
    SKIN_TYPE: 'skinType',
    HAIR_COLOR: 'hairColor',
    BODY_TYPE: 'bodyType',
    BODY_MODIFICATIONS: 'bodyModifications',
    AGE: 'age',
    PUBIC_HAIR: 'pubicHair',
    EYE_COLOR: 'eyeColor',
    GENDER: 'gender',
    CUP_SIZE: 'cupSize',
    SEXUALITY: 'sexuality',
    SPOKEN_LANGUAGES: 'spokenLanguages',
    BIRTHDAY: 'birthday',
    VIP_CLIPS: 'vip',
    VIDEO_SALE: 'discount',
    FREE_VIDEOS: 'free',
    BOUGHT_VIDEOS: 'bought',
    VIDEO_TAG: 'videoTag',
    VIDEO_TYPE: 'videoType',
    DEFAULT_FILTER: 'defaultFilter',
    DEFAULT_FILTER_TYPE: 'defaultFilterType',
    ACTING_GROUPS: 'actingGroups',
};

const _Filters = {
    COUNTRY: { //eq
        KEY: _KEYS.COUNTRY, VALUE: {
            DE: {KEY: 'DE', VALUE: {[_KEYS.COUNTRY]: {eq: 'DE'}}},
            ES: {KEY: 'ES', VALUE: {[_KEYS.COUNTRY]: {eq: 'ES'}}},
            PL: {KEY: 'PL', VALUE: {[_KEYS.COUNTRY]: {eq: 'PL'}}},
            FR: {KEY: 'FR', VALUE: {[_KEYS.COUNTRY]: {eq: 'FR'}}},
            RU: {KEY: 'RU', VALUE: {[_KEYS.COUNTRY]: {eq: 'RU'}}},
        }
    }, SKIN_TYPE: { //eq
        KEY: _KEYS.SKIN_TYPE, VALUE: {
            ASIAN: {KEY: 'ASIAN', VALUE: {[_KEYS.SKIN_TYPE]: {eq: 'ASIAN'}}}, BLACK: {
                KEY: 'BLACKSKINNED', VALUE: {
                    or: [{[_KEYS.SKIN_TYPE]: {eq: 'BLACKSKINNED'}}, {[_KEYS.SKIN_TYPE]: {eq: 'DARKSKINNED'}}, {[_KEYS.SKIN_TYPE]: {eq: 'AFROAMERICAN'}}]
                }
            }, LATINA: {KEY: 'LATINAMERICAN', VALUE: {[_KEYS.SKIN_TYPE]: {eq: 'LATINAMERICAN'}}},
        }
    }, HAIR_COLOR: { //eq
        KEY: _KEYS.HAIR_COLOR, VALUE: {
            BLOND: {KEY: 'BLOND', VALUE: {[_KEYS.HAIR_COLOR]: {eq: 'BLOND'}}},
            BROWN: {KEY: 'BROWN', VALUE: {[_KEYS.HAIR_COLOR]: {eq: 'BROWN'}}},
            BLACK: {KEY: 'BLACK', VALUE: {[_KEYS.HAIR_COLOR]: {eq: 'BLACK'}}},
            RED: {KEY: 'RED', VALUE: {[_KEYS.HAIR_COLOR]: {eq: 'RED'}}},
            MULTICOLOURED: {KEY: 'MULTICOLOURED', VALUE: {[_KEYS.HAIR_COLOR]: {eq: 'MULTICOLOURED'}}},
        }
    }, BODY_TYPE: { //eq
        KEY: _KEYS.BODY_TYPE, VALUE: {
            THIN: {KEY: 'THIN', VALUE: {[_KEYS.BODY_TYPE]: {eq: 'THIN'}}},
            AVERAGE: {KEY: 'AVERAGE', VALUE: {[_KEYS.BODY_TYPE]: {eq: 'AVERAGE'}}},
            ATHLETIC: {KEY: 'ATHLETIC', VALUE: {[_KEYS.BODY_TYPE]: {eq: 'ATHLETIC'}}},
            FAT: {KEY: 'FAT', VALUE: {[_KEYS.BODY_TYPE]: {eq: 'FAT'}}},
        }
    }, BODY_MODIFICATIONS: { //in
        KEY: _KEYS.BODY_MODIFICATIONS, VALUE: {
            HEAVILYTATTOOED: {
                KEY: 'HEAVILYTATTOOED',
                VALUE: {[_KEYS.BODY_MODIFICATIONS]: {contains: ['HEAVILYTATTOOED']}}
            },
            PECTORALPIERCING: {
                KEY: 'PECTORALPIERCING',
                VALUE: {[_KEYS.BODY_MODIFICATIONS]: {contains: ['PECTORALPIERCING']}}
            },
        }
    }, SPOKEN_LANGUAGES: {
        KEY: _KEYS.SPOKEN_LANGUAGES, VALUE: {
            DE: {KEY: 'DE', VALUE: {[_KEYS.SPOKEN_LANGUAGES]: {contains: ['DE']}}},
            EN: {KEY: 'EN', VALUE: {[_KEYS.SPOKEN_LANGUAGES]: {contains: ['EN']}}},
            FR: {KEY: 'FR', VALUE: {[_KEYS.SPOKEN_LANGUAGES]: {contains: ['FR']}}},
            IT: {KEY: 'IT', VALUE: {[_KEYS.SPOKEN_LANGUAGES]: {contains: ['IT']}}},
            ES: {KEY: 'ES', VALUE: {[_KEYS.SPOKEN_LANGUAGES]: {contains: ['ES']}}},
            DA: {KEY: 'DA', VALUE: {[_KEYS.SPOKEN_LANGUAGES]: {contains: ['DA']}}},
            FI: {KEY: 'FI', VALUE: {[_KEYS.SPOKEN_LANGUAGES]: {contains: ['FI']}}},
            NL: {KEY: 'NL', VALUE: {[_KEYS.SPOKEN_LANGUAGES]: {contains: ['NL']}}},
            PL: {KEY: 'PL', VALUE: {[_KEYS.SPOKEN_LANGUAGES]: {contains: ['PL']}}},
            PT: {KEY: 'PT', VALUE: {[_KEYS.SPOKEN_LANGUAGES]: {contains: ['PT']}}},
            RU: {KEY: 'RU', VALUE: {[_KEYS.SPOKEN_LANGUAGES]: {contains: ['RU']}}},
            TR: {KEY: 'TR', VALUE: {[_KEYS.SPOKEN_LANGUAGES]: {contains: ['TR']}}},
            CZ: {KEY: 'CZ', VALUE: {[_KEYS.SPOKEN_LANGUAGES]: {contains: ['CZ']}}},
            HU: {KEY: 'HU', VALUE: {[_KEYS.SPOKEN_LANGUAGES]: {contains: ['HU']}}},
            RO: {KEY: 'RO', VALUE: {[_KEYS.SPOKEN_LANGUAGES]: {contains: ['RO']}}},
        }
    }, AGE: { //eq, lt, gt, lte, gte,
        KEY: _KEYS.AGE, VALUE: {
            TEEN: {
                KEY: 'TEEN', VALUE: {
                    and: [{age: {gte: 18}}, {age: {lte: 19}},]
                }
            }, "20-29": {
                KEY: '20-29', VALUE: {
                    and: [{age: {gte: 20}}, {age: {lte: 29}},]
                }
            }, "30-39": {
                KEY: '30-39', VALUE: {
                    and: [{age: {gte: 30}}, {age: {lte: 39}},]
                }
            }, MILF: {
                KEY: 'MILF', VALUE: {
                    and: [{age: {gte: 40}}, {age: {lte: 59}},]
                }
            }, GRANDMA: {KEY: 'GRANDMA', VALUE: {age: {gte: 60}}}
        },
    }, PUBIC_HAIR: { //eq
        KEY: _KEYS.PUBIC_HAIR, VALUE: {
            SHAVED: {KEY: 'SHAVED', VALUE: {[_KEYS.PUBIC_HAIR]: {eq: 'SHAVED'}}},
            PARTIALLY_SHAVED: {KEY: 'PARTIALLY_SHAVED', VALUE: {[_KEYS.PUBIC_HAIR]: {eq: 'PARTIALLY_SHAVED'}}},
            HAIRY: {KEY: 'HAIRY', VALUE: {[_KEYS.PUBIC_HAIR]: {eq: 'HAIRY'}}},
        }
    }, EYE_COLOR: { //eq
        KEY: _KEYS.EYE_COLOR, VALUE: {
            BLUE: {KEY: 'BLUE', VALUE: {[_KEYS.EYE_COLOR]: {eq: 'BLUE'}}},
            BROWN: {KEY: 'BROWN', VALUE: {[_KEYS.EYE_COLOR]: {eq: 'BROWN'}}},
            GREEN: {KEY: 'GREEN', VALUE: {[_KEYS.EYE_COLOR]: {eq: 'GREEN'}}},
            GREY: {KEY: 'GREY', VALUE: {[_KEYS.EYE_COLOR]: {eq: 'GREY'}}},
        }
    }, GENDER: { //eq
        KEY: _KEYS.GENDER, VALUE: {
            F: {KEY: 'F', VALUE: Flux.Constants.Vxql.Videos.ActingGroups.FEMALES},
            M: {KEY: 'M', VALUE: Flux.Constants.Vxql.Videos.ActingGroups.MALES},
            FM: {KEY: 'FM', VALUE: Flux.Constants.Vxql.Videos.ActingGroups.COUPLES},
            FF: {KEY: 'FF'},
            S: {KEY: 'S', VALUE: {[_KEYS.GENDER]: {eq: 'S'}}},
        }
    }, CUP_SIZE: { //eq
        KEY: _KEYS.CUP_SIZE, VALUE: {
            SMALL: {KEY: 'SMALL', VALUE: {[_KEYS.CUP_SIZE]: {eq: 'SMALL'}}},
            MEDIUM: {KEY: 'MEDIUM', VALUE: {[_KEYS.CUP_SIZE]: {eq: 'MEDIUM'}}},
            LARGE: {KEY: 'LARGE', VALUE: {[_KEYS.CUP_SIZE]: {eq: 'LARGE'}}},
            EXTRA_LARGE: {KEY: 'EXTRA_LARGE', VALUE: {[_KEYS.CUP_SIZE]: {eq: 'EXTRA_LARGE'}}},
        }
    }, SEXUALITY: { //eq
        KEY: _KEYS.SEXUALITY, VALUE: {
            STRAIGHT: {KEY: 'STRAIGHT', VALUE: {[_KEYS.SEXUALITY]: {eq: 'STRAIGHT'}}},
            BI: {KEY: 'BI', VALUE: {[_KEYS.SEXUALITY]: {eq: 'BI'}}},
            GAY: {KEY: 'GAY', VALUE: {[_KEYS.SEXUALITY]: {eq: 'GAY'}}},
        }
    }, BIRTHDAY: { //eq bool
        KEY: _KEYS.BIRTHDAY, VALUE: {KEY: 'birthday', VALUE: {[_KEYS.BIRTHDAY]: {eq: true}}},
    },

    ANAL: {
        KEY: _KEYS.VIDEO_TAG, VALUE: {KEY: 'anal', VALUE: "ANAL"},
    },

    PUSSY: {
        KEY: _KEYS.VIDEO_TAG, VALUE: {KEY: 'pussy', VALUE: "Muschi"},
    },

    FETISH: {
        KEY: _KEYS.VIDEO_TAG, VALUE: {KEY: 'fetish', VALUE: "Fetisch"},
    },

    BREASTS: {
        KEY: _KEYS.VIDEO_TAG, VALUE: {KEY: 'breasts', VALUE: "Brüste"},
    },

    SEX: {
        KEY: _KEYS.VIDEO_TAG, VALUE: {KEY: 'sex', VALUE: "Sex"},
    },

    PENETRATION: {
        KEY: _KEYS.VIDEO_TAG, VALUE: {KEY: 'penetration', VALUE: "Penetration"},
    },

    BLOWJOB: {
        KEY: _KEYS.VIDEO_TAG, VALUE: {KEY: 'blowjob', VALUE: "Blowjob"},
    },

    RIDING: {
        KEY: _KEYS.VIDEO_TAG, VALUE: {KEY: 'riding', VALUE: "Reiten"},
    },

    CUMSHOT: {
        KEY: _KEYS.VIDEO_TAG, VALUE: {KEY: 'cumshot', VALUE: "Cumshot"},
    },

    ORGASM: {
        KEY: _KEYS.VIDEO_TAG, VALUE: {KEY: 'orgasm', VALUE: "orgasmus"},
    },

    BLONDE: {
        KEY: _KEYS.VIDEO_TAG, VALUE: {KEY: 'blonde', VALUE: "Blondine"},
    },

    PENIS: {
        KEY: _KEYS.VIDEO_TAG, VALUE: {KEY: 'penis', VALUE: "Penis"},
    },

    TOYS: {
        KEY: _KEYS.VIDEO_TAG, VALUE: {KEY: 'toys', VALUE: "Toys"},
    },

    OUTDOOR: {
        KEY: _KEYS.VIDEO_TAG, VALUE: {KEY: 'outdoor', VALUE: "Draußen"},
    },

    HARDCORE: {
        KEY: _KEYS.VIDEO_TAG, VALUE: {KEY: 'hardcore', VALUE: "HARDCORE"},
    },

    MASTURBATION: {
        KEY: _KEYS.VIDEO_TAG, VALUE: {KEY: 'Selbstbefriedigung', VALUE: "Selbstbefriedigung"},
    }
};

function setActiveFilterTags(filter, newFilter) {
    return [...filter].map(item => {
        item.tags.map((tag) => {
            if (newFilter.key === tag.key && tag.text === newFilter.text) {
                tag.isActive = !tag.isActive;
            }
        });

        return item;
    });
}

function generateVideosV2Filter(filter, category) {
    if (filter.length < 1) {
        return {};
    }

    const groups = {};
    const activeFilter = {
        filter: {
            tags: [],
            types: [{}],
            actingGroups: [],
        }, modelFilter: {
            and: []
        }
    };

    // default filters first so we can overwrite them
    const sortedFilter = structuredClone(filter);
    sortedFilter.sort((a, b) => {
        if (a.type === _KEYS.DEFAULT_FILTER) {
            return -1;
        }
        if (b.type === _KEYS.DEFAULT_FILTER) {
            return 1;
        }
        return 0;
    });

    let defaultFalseFilters = getDefaultFalseFiltersForCategory(category);

    defaultFalseFilters.map((filter) => {
        activeFilter.filter.types[0][filter] = false;
    });

    sortedFilter.map((tag) => {
        if (tag.type === _KEYS.DEFAULT_FILTER) {
            activeFilter.filter[tag.value.KEY] = tag.value.VALUE;
        } else if (tag.type === _KEYS.DEFAULT_FILTER_TYPE) {
            activeFilter.filter.types[0][tag.value.KEY] = tag.value.VALUE;
        } else if (tag.type === _KEYS.VIDEO_TAG) {
            activeFilter.filter.tags.push(tag.value.VALUE);
        } else if (tag.type === _KEYS.VIDEO_TYPE) {
            activeFilter.filter.types[0][tag.value.KEY] = tag.value.VALUE[tag.value.KEY];
        } else if (tag.type === _KEYS.ACTING_GROUPS) {
            activeFilter.filter.actingGroups.push(tag.value.VALUE);
        } else if (tag.type === 'tag') {
            if (!groups['tags']) {
                groups['tags'] = {'tags': {contains: []}};
            }
            groups['tags'].tags.contains.push(tag.value);
        } else {
            if (!groups[tag.key]) {
                groups[tag.key] = {or: []};
            }
            groups[tag.key].or.push(tag.value.VALUE);
        }
    });

    for (const key in groups) {
        activeFilter.modelFilter.and.push(groups[key]);
    }

    if (activeFilter.modelFilter.and.length === 0) {
        delete activeFilter.modelFilter.and;
    }

    return activeFilter;
}

function getDefaultFalseFiltersForCategory(category) {
    switch (category) {
        case Constants.Video.CategoriesV2.ALL_VIDEOS:
            return [Flux.Constants.Video.Filter.CLASSIC, Flux.Constants.Video.Filter.CONTEST];
        case Constants.Video.CategoriesV2.NEW_VIDEOS:
            return [Flux.Constants.Video.Filter.CLASSIC, Flux.Constants.Video.Filter.CONTEST];
        case Constants.Video.CategoriesV2.TRENDING_VIDEOS:
            return [Flux.Constants.Video.Filter.CONTEST];
        case Constants.Video.CategoriesV2.FREE_VIDEOS:
            return [];
        case Constants.Video.CategoriesV2.DISCOUNTED_VIDEOS:
            return [Flux.Constants.Video.Filter.CONTEST];
        default:
            return [Flux.Constants.Video.Filter.CLASSIC, Flux.Constants.Video.Filter.CONTEST];
    }
}

function getHiddenTagsForCategory(category) {
    let hiddenTags;
    switch (category) {
        case Constants.Video.CategoriesV2.ALL_VIDEOS:
        case Constants.Video.CategoriesV2.NEW_VIDEOS:
            hiddenTags = [Flux.Constants.Video.Filter.CONTEST, Flux.Constants.Video.Filter.CLASSIC];
            break;
        case Constants.Video.CategoriesV2.TRENDING_VIDEOS:
            hiddenTags = [Flux.Constants.Video.Filter.TRENDING];
            break;
        case Constants.Video.CategoriesV2.FREE_VIDEOS:
            hiddenTags = [Flux.Constants.Video.Filter.FREE];
            break;
        case Constants.Video.CategoriesV2.DISCOUNTED_VIDEOS:
            hiddenTags = [Flux.Constants.Video.Filter.DISCOUNT];
            break;
        default:
            hiddenTags = [];
    }
    if (!Flux.Guest.isLoggedIn()) {
        hiddenTags.push(Flux.Constants.Video.Filter.BOUGHT);
    }

    hiddenTags.push(Flux.Constants.Video.Filter.ORIGINAL);

    return hiddenTags;
}

function getTagsForCategory(category) {
    switch (category) {
        case Constants.Video.CategoriesV2.ALL_VIDEOS:
        case Constants.Video.CategoriesV2.NEW_VIDEOS:
            return {
                topFilter: {
                    premium: 1, discount: 2, free: 3, vip: 4
                },
                activeFilter: [Flux.Constants.Video.Filter.PREMIUM, Flux.Constants.Video.Filter.ORIGINAL, 'woman'],
            };
        case Constants.Video.CategoriesV2.TRENDING_VIDEOS:
            return {
                topFilter: {
                    premium: 1, discount: 2
                },
                activeFilter: [Flux.Constants.Video.Filter.PREMIUM, Flux.Constants.Video.Filter.TRENDING, Flux.Constants.Video.Filter.ORIGINAL, 'woman'],
            };
        case Constants.Video.CategoriesV2.FREE_VIDEOS:
            return {
                topFilter: {
                    woman: 1, premium: 2, vip: 3
                }, activeFilter: [Flux.Constants.Video.Filter.FREE, Flux.Constants.Video.Filter.ORIGINAL, 'woman'],
            };
        case Constants.Video.CategoriesV2.DISCOUNTED_VIDEOS:
            return {
                topFilter: {
                    premium: 1
                },
                activeFilter: [Flux.Constants.Video.Filter.PREMIUM, Flux.Constants.Video.Filter.DISCOUNT, Flux.Constants.Video.Filter.ORIGINAL, 'woman'],
            };
        default:
            return [];
    }
}

function mapCategoryToV2(category) {
    switch (category) {
        case Constants.Video.Categories.ALL:
            return Constants.Video.CategoriesV2.ALL_VIDEOS;
        case Constants.Video.Categories.NEWEST:
            return Constants.Video.CategoriesV2.NEW_VIDEOS;
        case Constants.Video.Categories.TRENDING:
            return Constants.Video.CategoriesV2.TRENDING_VIDEOS;
        case Constants.Video.Categories.FREE_WEEKLY:
            return Constants.Video.CategoriesV2.FREE_VIDEOS;
        case Constants.Video.Categories.ON_SALE:
            return Constants.Video.CategoriesV2.DISCOUNTED_VIDEOS;
        default:
            return Constants.Video.CategoriesV2.ALL_VIDEOS;
    }
}

function getDefaultFilter(category = null) {
    const isWomanFilterActive = getTagsForCategory(category).activeFilter.includes('woman');
    const FILTER = [{
        headline: ft('gender'), tags: [{
            text: ft('woman'),
            key: _Filters.GENDER.KEY,
            value: _Filters.GENDER.VALUE.F,
            isActive: isWomanFilterActive,
            isTopFilter: isWomanFilterActive ? getTagsForCategory(category).topFilter.woman : false,
            type: _KEYS.ACTING_GROUPS
        }, {
            text: ft('man'), key: _Filters.GENDER.KEY, value: _Filters.GENDER.VALUE.M, type: _KEYS.ACTING_GROUPS
        }, {text: ft('trans'), key: _Filters.GENDER.KEY, value: _Filters.GENDER.VALUE.S}, {
            text: ft('couples'), key: _Filters.GENDER.KEY, value: _Filters.GENDER.VALUE.FM, type: _KEYS.ACTING_GROUPS
        },]
    }, {
        headline: ft('country'),
        tags: [{text: ft('german'), key: _Filters.COUNTRY.KEY, value: _Filters.COUNTRY.VALUE.DE}, {
            text: ft('spanish'), key: _Filters.COUNTRY.KEY, value: _Filters.COUNTRY.VALUE.ES
        }, {text: ft('polish'), key: _Filters.COUNTRY.KEY, value: _Filters.COUNTRY.VALUE.PL}, {
            text: ft('french'), key: _Filters.COUNTRY.KEY, value: _Filters.COUNTRY.VALUE.FR
        }, {text: ft('russian'), key: _Filters.COUNTRY.KEY, value: _Filters.COUNTRY.VALUE.RU},]
    }, {
        headline: ft('language'), hidden: true, tags: [{
            text: ft('german'),
            key: _Filters.SPOKEN_LANGUAGES.KEY,
            value: _Filters.SPOKEN_LANGUAGES.VALUE.DE,
            hidden: true
        }, {
            text: ft('english'),
            key: _Filters.SPOKEN_LANGUAGES.KEY,
            value: _Filters.SPOKEN_LANGUAGES.VALUE.EN,
            hidden: true
        }, {
            text: ft('french'),
            key: _Filters.SPOKEN_LANGUAGES.KEY,
            value: _Filters.SPOKEN_LANGUAGES.VALUE.FR,
            hidden: true
        }, {
            text: ft('italy'),
            key: _Filters.SPOKEN_LANGUAGES.KEY,
            value: _Filters.SPOKEN_LANGUAGES.VALUE.IT,
            hidden: true
        }, {
            text: ft('spanish'),
            key: _Filters.SPOKEN_LANGUAGES.KEY,
            value: _Filters.SPOKEN_LANGUAGES.VALUE.ES,
            hidden: true
        }, {
            text: ft('da'),
            key: _Filters.SPOKEN_LANGUAGES.KEY,
            value: _Filters.SPOKEN_LANGUAGES.VALUE.DA,
            hidden: true
        }, {
            text: ft('finnish'),
            key: _Filters.SPOKEN_LANGUAGES.KEY,
            value: _Filters.SPOKEN_LANGUAGES.VALUE.FI,
            hidden: true
        }, {
            text: ft('netherlands'),
            key: _Filters.SPOKEN_LANGUAGES.KEY,
            value: _Filters.SPOKEN_LANGUAGES.VALUE.NL,
            hidden: true
        }, {
            text: ft('polish'),
            key: _Filters.SPOKEN_LANGUAGES.KEY,
            value: _Filters.SPOKEN_LANGUAGES.VALUE.PL,
            hidden: true
        }, {
            text: ft('pt'), key: _Filters.SPOKEN_LANGUAGES.KEY, value: _Filters.SPOKEN_LANGUAGES.VALUE.PT, hidden: true
        }, {
            text: ft('russia'),
            key: _Filters.SPOKEN_LANGUAGES.KEY,
            value: _Filters.SPOKEN_LANGUAGES.VALUE.RU,
            hidden: true
        }, {
            text: ft('tr'), key: _Filters.SPOKEN_LANGUAGES.KEY, value: _Filters.SPOKEN_LANGUAGES.VALUE.TR, hidden: true
        }, {
            text: ft('czech'),
            key: _Filters.SPOKEN_LANGUAGES.KEY,
            value: _Filters.SPOKEN_LANGUAGES.VALUE.CZ,
            hidden: true
        }, {
            text: ft('hungary'),
            key: _Filters.SPOKEN_LANGUAGES.KEY,
            value: _Filters.SPOKEN_LANGUAGES.VALUE.HU,
            hidden: true
        }, {
            text: ft('romania'),
            key: _Filters.SPOKEN_LANGUAGES.KEY,
            value: _Filters.SPOKEN_LANGUAGES.VALUE.RO,
            hidden: true
        },]
    }, {
        headline: ft('skin_color'),
        tags: [{text: ft('asian'), key: _Filters.SKIN_TYPE.KEY, value: _Filters.SKIN_TYPE.VALUE.ASIAN}, {
            text: ft('black'), key: _Filters.SKIN_TYPE.KEY, value: _Filters.SKIN_TYPE.VALUE.BLACK
        }, {text: ft('latina'), key: _Filters.SKIN_TYPE.KEY, value: _Filters.SKIN_TYPE.VALUE.LATINA},]
    }, {
        headline: ft('body'),
        tags: [{text: ft('thin'), key: _Filters.BODY_TYPE.KEY, value: _Filters.BODY_TYPE.VALUE.THIN}, {
            text: ft('bbw'), key: _Filters.BODY_TYPE.KEY, value: _Filters.BODY_TYPE.VALUE.FAT
        }, {text: ft('average'), key: _Filters.BODY_TYPE.KEY, value: _Filters.BODY_TYPE.VALUE.AVERAGE}, {
            text: ft('athletic'), key: _Filters.BODY_TYPE.KEY, value: _Filters.BODY_TYPE.VALUE.ATHLETIC
        },]
    }, {
        headline: ft('body_art'), tags: [{
            text: ft('tattoo'),
            key: _Filters.BODY_MODIFICATIONS.KEY,
            value: _Filters.BODY_MODIFICATIONS.VALUE.HEAVILYTATTOOED
        }, /* {text: ft(''), key:_Filters.BODY_MODIFICATIONS.KEY, value: _Filters.BODY_MODIFICATIONS.VALUE.INTIMATETATTOO},*/
            {
                text: ft('piercing'),
                key: _Filters.BODY_MODIFICATIONS.KEY,
                value: _Filters.BODY_MODIFICATIONS.VALUE.PECTORALPIERCING
            }, /*{text: 'Intimpiercing', key:_Filters.BODY_MODIFICATIONS.KEY, value: _Filters.BODY_MODIFICATIONS.VALUE.INTIMATEPIERCING},*/]
    }, {
        headline: ft('hair_color'), tags: [{
            text: ft('black_hair'), key: _Filters.HAIR_COLOR.KEY, value: _Filters.HAIR_COLOR.VALUE.BLACK, color: 'black'
        }, {text: ft('blonde'), key: _Filters.HAIR_COLOR.KEY, value: _Filters.HAIR_COLOR.VALUE.BLOND, color: 'blond'}, {
            text: ft('brown_hair'), key: _Filters.HAIR_COLOR.KEY, value: _Filters.HAIR_COLOR.VALUE.BROWN, color: 'brown'
        }, {text: ft('red'), key: _Filters.HAIR_COLOR.KEY, value: _Filters.HAIR_COLOR.VALUE.RED, color: 'red'}, {
            text: ft('multicolored'),
            key: _Filters.HAIR_COLOR.KEY,
            value: _Filters.HAIR_COLOR.VALUE.MULTICOLOURED,
            color: 'color'
        },]
    }, {
        headline: ft('eye_color'),
        tags: [{text: ft('blue'), key: _Filters.EYE_COLOR.KEY, value: _Filters.EYE_COLOR.VALUE.BLUE, color: 'blue'}, {
            text: ft('brown'), key: _Filters.EYE_COLOR.KEY, value: _Filters.EYE_COLOR.VALUE.BROWN, color: 'brown'
        }, {text: ft('green'), key: _Filters.EYE_COLOR.KEY, value: _Filters.EYE_COLOR.VALUE.GREEN, color: 'green'}, {
            text: ft('gray'), key: _Filters.EYE_COLOR.KEY, value: _Filters.EYE_COLOR.VALUE.GREY, color: 'gray'
        },]
    }, {
        headline: ft('age'), tags: [{text: ft('teen'), key: _Filters.AGE.KEY, value: _Filters.AGE.VALUE.TEEN}, {
            text: '18-29', key: _Filters.AGE.KEY, value: _Filters.AGE.VALUE["20-29"]
        }, {text: '30-39', key: _Filters.AGE.KEY, value: _Filters.AGE.VALUE["30-39"]}, {
            text: ft('milf'), texts: {
                [_Filters.GENDER.KEY]: {
                    [_Filters.GENDER.VALUE.F.KEY]: ft('milf'),
                    [_Filters.GENDER.VALUE.FF.KEY]: ft('milf'),
                    [_Filters.GENDER.VALUE.FM.KEY]: ft('milf'),
                    [_Filters.GENDER.VALUE.M.KEY]: ft('daddy'),
                    [_Filters.GENDER.VALUE.S.KEY]: ft('daddy'),
                }
            }, key: _Filters.AGE.KEY, value: _Filters.AGE.VALUE.MILF, isActive: false,
        }, {
            text: ft('grandma'), texts: {
                [_Filters.GENDER.KEY]: {
                    [_Filters.GENDER.VALUE.F.KEY]: ft('grandma'),
                    [_Filters.GENDER.VALUE.FF.KEY]: ft('grandma'),
                    [_Filters.GENDER.VALUE.FM.KEY]: ft('grandma'),
                    [_Filters.GENDER.VALUE.M.KEY]: ft('sixty_plus'),
                    [_Filters.GENDER.VALUE.S.KEY]: ft('sixty_plus'),
                }
            }, key: _Filters.AGE.KEY, value: _Filters.AGE.VALUE.GRANDMA, isActive: false
        }, {text: ft('birthday'), key: _Filters.BIRTHDAY.KEY, value: _Filters.BIRTHDAY.VALUE},]
    }, {
        headline: ft('breasts'), hide: {
            [_Filters.GENDER.KEY]: [_Filters.GENDER.VALUE.M.KEY]
        }, tags: [{text: ft('short'), key: _Filters.CUP_SIZE.KEY, value: _Filters.CUP_SIZE.VALUE.SMALL}, {
            text: ft('normal'), key: _Filters.CUP_SIZE.KEY, value: _Filters.CUP_SIZE.VALUE.MEDIUM
        }, {text: ft('tall'), key: _Filters.CUP_SIZE.KEY, value: _Filters.CUP_SIZE.VALUE.LARGE}, {
            text: ft('mega'), key: _Filters.CUP_SIZE.KEY, value: _Filters.CUP_SIZE.VALUE.EXTRA_LARGE
        },]
    }, {
        headline: ft('intimate_shaving'),
        tags: [{text: ft('shaved'), key: _Filters.PUBIC_HAIR.KEY, value: _Filters.PUBIC_HAIR.VALUE.SHAVED}, {
            text: ft('partially_shaved'),
            key: _Filters.PUBIC_HAIR.KEY,
            value: _Filters.PUBIC_HAIR.VALUE.PARTIALLY_SHAVED
        }, {text: ft('hairy'), key: _Filters.PUBIC_HAIR.KEY, value: _Filters.PUBIC_HAIR.VALUE.HAIRY},]
    }, {
        headline: ft('orientation'),
        tags: [{text: ft('straight'), key: _Filters.SEXUALITY.KEY, value: _Filters.SEXUALITY.VALUE.STRAIGHT}, {
            text: ft('bi'), key: _Filters.SEXUALITY.KEY, value: _Filters.SEXUALITY.VALUE.BI
        }, {
            text: ft('lesbian'), texts: {
                [_Filters.GENDER.KEY]: {
                    [_Filters.GENDER.VALUE.F.KEY]: ft('lesbian'),
                    [_Filters.GENDER.VALUE.FF.KEY]: ft('lesbian'),
                    [_Filters.GENDER.VALUE.FM.KEY]: ft('lesbian'),
                    [_Filters.GENDER.VALUE.M.KEY]: ft('gay'),
                    [_Filters.GENDER.VALUE.S.KEY]: ft('gay'),
                }
            }, key: _Filters.SEXUALITY.KEY, value: _Filters.SEXUALITY.VALUE.GAY, isActive: false, isTopFilter: false
        },]
    }, {
        headline: ft('popular'), type: TYPE_VIDEO_FILTER, tags: [{
            text: ftTag('anal'),
            key: _Filters.ANAL.KEY,
            value: _Filters.ANAL.VALUE,
            type: _KEYS.VIDEO_TAG,
            isTopFilter: 6
        }, {text: ftTag('pussy'), key: _Filters.PUSSY.KEY, value: _Filters.PUSSY.VALUE, type: _KEYS.VIDEO_TAG}, {
            text: ftTag('Fetish'),
            key: _Filters.FETISH.KEY,
            value: _Filters.FETISH.VALUE,
            type: _KEYS.VIDEO_TAG,
            isTopFilter: 7
        }, {
            text: ftTag('hardcore'),
            key: _Filters.HARDCORE.KEY,
            value: _Filters.HARDCORE.VALUE,
            type: _KEYS.VIDEO_TAG,
            isTopFilter: 8
        }, {
            text: ftTag('boobs'),
            key: _Filters.BREASTS.KEY,
            value: _Filters.BREASTS.VALUE,
            type: _KEYS.VIDEO_TAG,
            isTopFilter: 9
        }, {
            text: ftTag('masturbation'),
            key: _Filters.MASTURBATION.KEY,
            value: _Filters.MASTURBATION.VALUE,
            type: _KEYS.VIDEO_TAG,
            isTopFilter: 10
        }, {text: ftTag('sex'), key: _Filters.SEX.KEY, value: _Filters.SEX.VALUE, type: _KEYS.VIDEO_TAG}, {
            text: ftTag('penetration'),
            key: _Filters.PENETRATION.KEY,
            value: _Filters.PENETRATION.VALUE,
            type: _KEYS.VIDEO_TAG
        }, {text: ftTag('blowjob'), key: _Filters.BLOWJOB.KEY, value: _Filters.BLOWJOB.VALUE, type: _KEYS.VIDEO_TAG}, {
            text: ftTag('riding'), key: _Filters.RIDING.KEY, value: _Filters.RIDING.VALUE, type: _KEYS.VIDEO_TAG
        }, {text: ftTag('cumshot'), key: _Filters.CUMSHOT.KEY, value: _Filters.CUMSHOT.VALUE, type: _KEYS.VIDEO_TAG}, {
            text: ftTag('orgasm'), key: _Filters.ORGASM.KEY, value: _Filters.ORGASM.VALUE, type: _KEYS.VIDEO_TAG
        }, {text: ftTag('blonde'), key: _Filters.BLONDE.KEY, value: _Filters.BLONDE.VALUE, type: _KEYS.VIDEO_TAG}, {
            text: ftTag('penis'), key: _Filters.PENIS.KEY, value: _Filters.PENIS.VALUE, type: _KEYS.VIDEO_TAG
        }, {text: ftTag('Toys'), key: _Filters.TOYS.KEY, value: _Filters.TOYS.VALUE, type: _KEYS.VIDEO_TAG}, {
            text: ftTag('outdoor'), key: _Filters.OUTDOOR.KEY, value: _Filters.OUTDOOR.VALUE, type: _KEYS.VIDEO_TAG
        },]
    }];

    const tagTopFilter = [];
    const alwaysHiddenTags = [Flux.Constants.Video.Filter.ORIGINAL, Flux.Constants.Video.Filter.TRENDING, Flux.Constants.Video.Filter.CLASSIC];
    const groups = VXConfig.enumTagGroups.videos;

    for (const key in groups) {
        if (groups.hasOwnProperty(key)) {
            const headline = Translations.get(`tags.${key}`);
            const tags = groups[key].map(tag => ({
                text: Translations.get('tags.' + tag),
                key: headline,
                value: Translations.get('tags.' + tag),
                isTopFilter: tagTopFilter.find(top => top.tag === tag) ? tagTopFilter.find(top => top.tag === tag).pos : false,
                isActive: false,
                type: 'tag',
                tag: tag
            }));

            FILTER.push({headline, tags});
        }
    }

    if (category) {
        let defaultFilter = Flux.VideoV2.getDefaultFilterForCategory(category);

        Object.keys(defaultFilter).forEach(key => {
            if (defaultFilter[key] instanceof Array) {
                defaultFilter[key].forEach((element) => {
                    if (element !== null && typeof element === 'object') {
                        let tagList = [];
                        Object.entries(element).forEach(([prop, value]) => {
                            let newTag = {
                                text: Translations.get('tags.' + prop),
                                key: key,
                                // "value" decides what should happen if Filter is toggled
                                // "default-value = null" means no filtering at all if inactive -> So filter needs to be true if active (must include this type)
                                // "default-value = false" means exclude this type if inactive  -> So filter needs to null if active (no filtering)
                                value: {KEY: prop, VALUE: value === null ? true : (value === false ? null : value)},
                                type: _KEYS.DEFAULT_FILTER_TYPE,
                                // "isActive" decides is Filter is toggelled by default
                                isActive: getTagsForCategory(category).activeFilter.includes(prop),
                                isTopFilter: getTagsForCategory(category).topFilter.hasOwnProperty(prop) ? getTagsForCategory(category).topFilter[prop] : false,
                                hidden: alwaysHiddenTags.includes(prop) || getHiddenTagsForCategory(category).includes(prop) || !getTagsForCategory(category).topFilter.hasOwnProperty(prop),
                            };

                            tagList.push(newTag);
                        });

                        FILTER.push({
                            headline: Translations.get('FilterVideoTypeLabel'),
                            type: TYPE_VIDEO_FILTER,
                            hidden: false,
                            tags: tagList
                        });
                    }
                });
            } else {
                FILTER.push({
                    headline: key, hidden: true, tags: [{
                        key: key,
                        value: {KEY: key, VALUE: defaultFilter[key]},
                        type: _KEYS.DEFAULT_FILTER,
                        isActive: true,
                        hidden: true,
                        text: key,
                    }]
                });
            }
        });
    }

    return FILTER;
}

export {
    getDefaultFilter, generateVideosV2Filter, setActiveFilterTags, mapCategoryToV2, getHiddenTagsForCategory, _KEYS,
};
